import { useState, useMemo } from 'react';

export const usePagination = <T,>(items: T[], pageSize: number = 10) => {
  const [page, setPage] = useState(1);

  const paginatedItems = useMemo(() => {
    const startIndex = (page - 1) * pageSize;
    const endIndex = startIndex + pageSize;
    return items.slice(startIndex, endIndex);
  }, [items, page, pageSize]);

  const totalPages = Math.ceil(items.length / pageSize);

  const goToPage = (pageNum: number) => {
    const validPage = Math.max(1, Math.min(pageNum, totalPages));
    setPage(validPage);
  };

  const nextPage = () => goToPage(page + 1);
  const prevPage = () => goToPage(page - 1);

  return {
    page,
    pageSize,
    totalPages,
    total: items.length,
    paginatedItems,
    goToPage,
    nextPage,
    prevPage,
    hasNextPage: page < totalPages,
    hasPrevPage: page > 1,
  };
};
